module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms_m_jp.dfe419b33cc378373ba5187f3db5d117.png";